import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import {
  fetchAnnualProgressAuditSnapshot,
  type AnnualProgressAuditSnapshot,
} from '../../services/programPresentationAuditService';
import { loadAnnualPresentationAuditSnapshotCache } from '../../utils/presentationAuditSnapshotCache';
import { schoolKeys } from '../keys';
import { lsInitialDataOptions } from './lsInitialData';

export type UseAnnualPresentationAuditQueryParams = {
  workspaceId: string;
  academicYear: number;
  termNumber: 1 | 2;
  gradeId: string;
  enabled?: boolean;
  forceRefresh?: boolean;
};

export function useAnnualPresentationAuditQuery(
  params: UseAnnualPresentationAuditQueryParams
): UseQueryResult<AnnualProgressAuditSnapshot> {
  const {
    workspaceId,
    academicYear,
    termNumber,
    gradeId,
    enabled = true,
    forceRefresh = false,
  } = params;

  const ls = loadAnnualPresentationAuditSnapshotCache(workspaceId, academicYear, termNumber, gradeId);
  const lsSnapshot: AnnualProgressAuditSnapshot | undefined = ls
    ? {
        programProgressCells: [],
        scopedRows: [],
        fixedRows: [],
        presentationEntries: ls.presentationEntries,
        worksheetEntries: [],
      }
    : undefined;

  return useQuery<AnnualProgressAuditSnapshot>({
    queryKey: schoolKeys.annualPresentationAudit(workspaceId, academicYear, termNumber, gradeId),
    enabled: enabled && !!workspaceId.trim() && !!gradeId.trim(),
    ...lsInitialDataOptions(!!ls, lsSnapshot!, ls?.savedAt),
    queryFn: () =>
      fetchAnnualProgressAuditSnapshot(
        { workspaceId, academicYear, termNumber, gradeId },
        { forceRefresh }
      ),
  });
}
